import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import { useMediaQuery } from 'react-responsive';
import Grid from '@mui/material/Grid';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';
import uuid from 'react-uuid';

import { LocalizationContext } from '../../App';



const LoupeChipConditionalLikertItem = props => {

    const isMobileView = useMediaQuery({        
        query: '(max-width: 900px)'
    });
    const isWideView = useMediaQuery({
        query: '(min-width: 1200px)'
    });
    const isNarrowDesktop = useMediaQuery({
        query: '(min-width: 900px)'
    });

    const callbackHandler = props.callbackHandler;
    const currentItem = props.currentItem;

    const [state, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const [ chipValues ] = useState( currentItem.selectedValues );
    const [ value ] = React.useState(currentItem.scales);

    var renderedElements = 0;

    
    const itemRevalidation = () => {       

        // take care to validate content of this item. If no chips selected, it fulfills required interaction.
        // otherwise, for all items, a likert scale item must be selected.
        var hadError = false;
        if( currentItem.selectedValues.length == 0 ) {
            currentItem.validator.touched();
        } else {        
            currentItem.selectedValues.map(sel => {
                var origIdx = currentItem.itemOrder.indexOf(sel);
                if( currentItem.scales[origIdx].selectedValue == "" ) {
                    hadError = true;
                }                         
            });

            if(hadError){
                currentItem.validator.untouch();
            } else {
                currentItem.validator.touched();
            }

        }
        return hadError;
    }

    itemRevalidation();
    
    


    const isInResultset = value => {
        return currentItem.selectedValues.includes(value);
    }

    
    const handleChipClick = (chipValue, item) => {
        
        if(isInResultset(chipValue)) {

            var idx = currentItem.selectedValues.indexOf(chipValue);
            currentItem.selectedValues.splice(idx, 1);
            var origIdx = currentItem.itemOrder.indexOf(chipValue);            
            
            value[origIdx].setValue("");            

        } else {
            currentItem.selectedValues.push(chipValue);
        }

        if(currentItem.validator.instantRevalidation) {
            itemRevalidation();
            currentItem.validator.revalidate();
        }

        forceUpdate();
    }

    
    const myChange = (event, idx, obj) => {       
        obj.setValue(event.target.value);
        
        if(currentItem.validator.instantRevalidation) {
            itemRevalidation();
            currentItem.validator.revalidate();
        }
        
        forceUpdate();
       
    };
    
    


    return (

        <LocalizationContext.Consumer>
            { ({strings}) => 

            <div className="text-start mb-4">

                <LoupeItemHeaderComponent currentItem={currentItem} />
                <Grid container>
                    <Grid item xs={12} className="mb-5">
                        
                        { currentItem.choices.map(c => {
                            
                            const variant = (isInResultset(c['_attributes']['export-label'])) ? 'filled' : 'filled';
                            
                            return(
                                <Chip 
                                    style={{margin : '3px'}}
                                    onClick={(e) => handleChipClick(c['_attributes']['export-label'], e)}
                                    value={c['_attributes']['export-label']} 
                                    {...( isInResultset(c['_attributes']['export-label']) ? { color : 'primary'} : {})}
                                    variant={variant}
                                    key={`chip_${c['_attributes']['export-label']}`} 
                                    label={c['_attributes']['label']}/>
                            )
                        }) }

                    </Grid> 
                </Grid>
        
                { isMobileView == false ? 
                (
                    <>                    

                        <Grid container>

                            <Grid item xs={12}>
                                
                                <Grid container spacing={2} justifyContent="center">

                                    { value.map( (s, idx, arr) => {
                                    
                                        // we have to keep track about the number of items rendered, as this now determines in comparison to selection 
                                        var isLastItem = (renderedElements == chipValues.length - 1) ? true : false;
                                        var printInvisibleLabels = ( !isLastItem && currentItem.units == 0) ? true : false;
                                                                                    
                                        if( !isInResultset(s.exportLabel) ){ 
                                            return(
                                                <React.Fragment key={s.id + "_wrap"}></React.Fragment>                                                   
                                            );
                                        } else {
                                            renderedElements += 1;
                                            return ( 

                                                <React.Fragment key={s.id + "_wrap"}>
                                                
                                                    <Grid item xs={ isWideView == true ? 4 : 4 } justifyContent={"center"}>
                                                        {s.label}
                                                    </Grid>

                                                    <Grid item xs={ isWideView == true ? 7 : 7 } justifyContent={"center"}>

                                                        {/** This is the grid item of either 7 (wide) or 12 width*/ }
                                                        <Grid item xs={12}>
                                                            <RadioGroup                                                                                                                   
                                                                key={s.id + "_group"}
                                                                value={value[idx].selectedValue}
                                                                onChange={(event) => myChange(event, idx, s)}
                                                                row={true}>
                                                                    
                                                                { s.unitItems.map( (u, idx, arr) => {
                                                                    return(
                                                                        <FormControlLabel {...(isLastItem == true ? {} : { style : { color : 'transparent' }  })} labelPlacement={'bottom'} label={ (isLastItem || printInvisibleLabels) ? u.label : '' } value={u.value} key={u.id} control={<Radio />}/>
                                                                  );
                                                                })}
                                                                
                                                            </RadioGroup>
                                                        </Grid>                                                    
                                                        
                                                        
                                                        { (isLastItem && currentItem.minLabel != "") &&
                                                            <React.Fragment key={s.id + "_labelWrapper"}>
                                                                <p className="mb-4"/>
                                                                <div key={s.id + "_label"} style={{ alignContent : 'center' }}>{currentItem.minLabel} &mdash; {currentItem.maxLabel}</div>                                                                                                                   
                                                            </React.Fragment>
                                                        }                                                                                                                

                                                    </Grid>

                                                    <Grid item xs />
                                                    

                                                </React.Fragment>
                                            );
                                        }
                                    
                                    
                                    })}

                                
                                </Grid>                        

                            </Grid>

                        </Grid>     
                
                    </>
                ) : (
                    <>
                    <Grid container spacing={2}>
                        <Grid item xs/>
                            <Grid item xs={12}>     

                                    { value.map( (s, idx, arr) => {
                                        if( !isInResultset(s.exportLabel) ) {
                                            return(<React.Fragment key={s.id + "_wrap"}></React.Fragment>);

                                        } else {                                                    
                                            renderedElements += 1;                                                                                                            
                                            return (

                                                <Grid item xs={12} key={s.id + "_wrap"}>
                                                    
                                                        <p className="mb-4" />
                                                        <FormLabel>{s.label}</FormLabel>                                                          
                            
                                                            <RadioGroup
                                                                style={{ alignContent : 'center'}}
                                                                key={s.id + "_group"}
                                                                value={value[idx].selectedValue}
                                                                onChange={(event) => myChange(event, idx, s)}
                                                                row={false}>
                                                                
                                                                { s.unitItems.map( (u, idx, arr) => {

                                                                    var radioLabel = u.label;                                                                                                              
                                                                    // check for first element
                                                                    if( idx == 0 ) {
                                                                        radioLabel = <><span>{u.label}</span><span style={{marginLeft : '20px'}}>{currentItem.minLabel}</span></>;
                                                                    }

                                                                    // check for last element
                                                                    if( idx == (arr.length - 1)) {
                                                                        radioLabel = <><span>{u.label}</span><span style={{marginLeft : '20px'}}>{currentItem.maxLabel}</span></>;
                                                                    }

                                                                    return(
                                                                        <FormControlLabel labelPlacement={'end'} label={radioLabel} value={u.value} key={u.id} control={<Radio />}/>
                                                                    );
                                                                })}

                                                            </RadioGroup>
                                                        
                                                    
                                                </Grid>                                        

                                            );
                                        }

                                    }) }
                            </Grid>
                        <Grid item xs/>
                    </Grid>
                        

                    
                    
                    </>
                )} 
                                    
  
                       
                            
                

            </div>
            }
        </LocalizationContext.Consumer>
    );

}
export default LoupeChipConditionalLikertItem;